import {
  IconAward,
  IconBook,
  IconTrendingDown,
  IconTrendingUp,
  IconUsers
} from '@tabler/icons-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getStat } from '../../store/dashboardSlice';
import { Card } from '../ui/card';

const DashboardCard = ({ title, value, icon: Icon, loading = false, trend, description, trendDirection = "up" }) => {
  const TrendIcon = trendDirection === "up" ? IconTrendingUp : IconTrendingDown;
  // Ensure value is a valid number or string
  const displayValue = value !== null && value !== undefined ? value : '--';

  return (
    <Card className="border border-border bg-card rounded-2xl p-6 shadow-sm">
      <div className="flex items-start justify-between mb-2">
        <span className="text-sm text-muted-foreground font-medium">{title}</span>
        {trend && (
          <span className="flex items-center gap-1 rounded-full border border-border bg-muted/30 px-2 py-0.5 text-xs font-medium text-muted-foreground">
            <TrendIcon className="w-4 h-4" />
            {trend}
          </span>
        )}
      </div>
      <div className="text-4xl font-bold text-foreground mb-6 tabular-nums">
        {loading ? (
          <span className="text-muted-foreground text-base">Loading...</span>
        ) : (
          displayValue
        )}
      </div>
      <div className="mt-2">
        <div className="flex items-center gap-2 font-semibold text-foreground mb-1">
          {trendDirection === "up" ? "Trending up" : "Trending down"} this month
          <TrendIcon className="w-4 h-4" />
        </div>
        <div className="text-sm text-muted-foreground">
          {description || "Performance metrics"}
        </div>
      </div>
    </Card>
  );
};

export default function Dashboard() {
  const dispatch = useDispatch();
  const { programCount, courseCount, lessonCount } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(getStat());
  }, [dispatch]);

  const stats = [
    { title: "Programs", value: programCount || 0, trend: "+5.2%", trendDirection: "up", icon: IconAward },
    { title: "Courses", value: courseCount || 0, trend: "+12.1%", trendDirection: "up", icon: IconBook },
    { title: "Lessons", value: lessonCount || 0, trend: "+8.7%", trendDirection: "up", icon: IconBook },
    { title: "Active Users", value: "1,234", trend: "+15.3%", trendDirection: "up", icon: IconUsers },
  ];

  return (
    <div className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-6">
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat, index) => (
          <DashboardCard
            key={index}
            title={stat.title}
            value={stat.value}
            icon={stat.icon}
            trend={stat.trend}
            trendDirection={stat.trendDirection}
            description="vs last month"
          />
        ))}
      </div>
    </div>
  );
}